export const referenceList = [
    ['Mala sončna elektrarna Dolsko', '14,3 kWp'],
    ['Mala sončna elektrarna Cankova', '9,8 kWp'],
    ['Mala sončna elektrarna Na Klancu', '11,2 kWp'],
    ['Mala sončna elektrarna Osredke I', '10,2 kWp'],
    ['Mala sončna elektrarna Podkraj', '13,5 kWp'],
    ['Balkonska sončna elektrarna ', '600 Wp'],
    ['Mala sončna elektrarna Tevče', '17 kWp'],
    ['Mala sončna elektrarna Štanjevci II', '11 kWp'],
    ['Mala sončna elektrarna Fram', '13,5 kWp'],
    ['Mala sončna elektrarna Podutik', '12 kWp'],
    ['Mala sončna elektrarna Dolenje Ponikve', '11,5 kWp'],
    ['Sončna elektrarna Zavod Hrastovec', '24,2 kWp'],
    ['Sončna elektrarna Radomlje', '8,8 kWp'],
    ['Sončna elektrarna Kočevje', '12,6 kWp'],
    ['Sončna elektrarna Domžale', '13,02 kWp'],
    ['Sončna elektrarna Kranj', '13,6 kWp'],
]

export const referenceList2 = [
    ['Sončna elektrarna Šmarje pri Jelšah', '150 kWp'],
    ['Sončna elektrarna Šmarje pri Jelšah', '150 kWp'],
    ['Sončna elektrarna Slovenjske Konjice', '300 kWp'],
    ['Sončna elektrarna Slovenjske Konjice', '300 kWp'],
    ['Sončna elektrarna Slovenjske Konjice', '300 kWp'],
    ['Sončna elektrarna Moste', '60 kWp'],
    ['Sončna elektrarna Moste', '60 kWp'],
    ['Sončna elektrarna Moste', '60 kWp'],
    ['Sončna elektrarna Medlog', '170 kWp'],
    ['Sončna elektrarna Medlog', '170 kWp'],
    ['Sončna elektrarna Medlog', '170 kWp'],
    ['Sončna elektrarna Srednje Bitnje', '62 kWp'],
    ['Sončna elektrarna Mislinjska Dobrava', '300 kWp'],
    ['Sončna elektrarna Mislinjska Dobrava', '300 kWp'],
    ['Sončna elektrarna Mislinjska Dobrava', '300 kWp'],
    ['Sončna elektrarna Koper', '35 kWp'],
    ['Sončna elektrarna Koper', '35 kWp'],
    ['Sončna elektrarna Kostrevnica', '45 kWp'],
]

export const referenceList3 = [
    ['Energetska skupnost Stara Fužina', '29 kWp'],
    ['Energetska skupnost Stara Fužina', '29 kWp'],
    ['Energetska skupnost Stara Fužina', '29 kWp'],
    ['Energetska skupnost Loški potok', '33,3 kWp'],
    ['Energetska skupnost Celje', '200 kWp'],
    ['Energetska skupnost Celje', '200 kWp'],
    ['Energetska skupnost Celje', '200 kWp'],
    ['Energetska skupnost Hrastnik', '287 kWp'],
    ['Energetska skupnost Hrastnik', '287 kWp'],
]
